import {
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    ListSubheader
} from '@mui/material'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { NavEntryBadge } from '../NavBadgeCount'

const itemSx = {
    borderRadius: 1,
    py: 0.5,
    px: 1.5,
    minHeight: 34,
    '&.Mui-selected': {
        color: 'primary.main',
        '& .MuiListItemText-primary': { fontWeight: 600 }
    }
}

/** Desktop admin nav: the area's overview, then one heading per category. */
export default function AdminSideNav({ area, groups, activeId, onOverview }) {
    return (
        <nav aria-label={area.title}>
            <List dense disablePadding>
                <ListItemButton
                    component={Link}
                    to={area.rootPath}
                    selected={onOverview}
                    aria-current={onOverview ? 'page' : undefined}
                    sx={itemSx}
                >
                    <ListItemIcon sx={{ minWidth: 30, color: 'inherit' }}>
                        {area.icon}
                    </ListItemIcon>
                    <ListItemText primary={area.overviewLabel} />
                </ListItemButton>
            </List>
            {groups.map((group) => (
                <List
                    key={group.id}
                    dense
                    disablePadding
                    aria-labelledby={`${area.id}-nav-${group.id}`}
                    subheader={
                        <ListSubheader
                            id={`${area.id}-nav-${group.id}`}
                            disableSticky
                            sx={{
                                bgcolor: 'transparent',
                                lineHeight: 1.5,
                                pt: 2.5,
                                pb: 0.5,
                                px: 1.5,
                                fontSize: '0.75rem',
                                fontWeight: 600,
                                letterSpacing: '0.04em',
                                textTransform: 'uppercase',
                                color: 'text.secondary'
                            }}
                        >
                            {group.title}
                        </ListSubheader>
                    }
                >
                    {group.items.map((item) => {
                        const selected = !onOverview && item.id === activeId
                        return (
                            <ListItemButton
                                key={item.id}
                                component={Link}
                                to={item.path}
                                selected={selected}
                                aria-current={selected ? 'page' : undefined}
                                sx={itemSx}
                            >
                                <ListItemText primary={item.label} />
                                {<NavEntryBadge item={item} />}
                            </ListItemButton>
                        )
                    })}
                </List>
            ))}
        </nav>
    )
}

AdminSideNav.propTypes = {
    area: PropTypes.shape({
        id: PropTypes.string.isRequired,
        icon: PropTypes.node,
        overviewLabel: PropTypes.string.isRequired,
        rootPath: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired
    }).isRequired,
    activeId: PropTypes.string,
    groups: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            items: PropTypes.array.isRequired
        })
    ).isRequired,
    onOverview: PropTypes.bool.isRequired
}
